import { Component, input } from '@angular/core';

@Component({
  selector: 'accredible-two-columns-layout',
  standalone: true,
  templateUrl: './two-columns-layout.component.html',
  styleUrl: './two-columns-layout.component.scss',
})
export class TwoColumnsLayoutComponent {
  backgroundImage = input<string>('/assets/images/two-columns-layout-component/layout-gray.png');
  leftColumnWidth = input<string>('50%');
  rightColumnWidth = input<string>('50%');
  singleColumn = input<boolean>(false);
}
